import { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BusinessSuiteContentLayout from "layout/business-suite-content/BusinessSuiteContentLayout";
import {
  Plus,
  Grid2x2,
  CircleStop,
  LoaderCircle,
  CircleOff,
  Trash2,
  CircleCheck,
  Calendar,
  AlignJustify,
  FolderSync,
  FileOutput,
  CreditCard,
  Save,
  Cake,
  Timer,
  BriefcaseBusiness,
  BookCheck,
  PrinterCheck,
  Loader,
  Settings,
  CircleAlert,
} from "lucide-react";
import { RequestApi, RouteApi, StatusMsg } from "utils";
import { useAppSelector } from "store/store";
import { AppLog } from "services";

import { useLocation } from "react-router-dom";
import InfiniteScroll from "react-infinite-scroll-component";
import { AppRecord, AppRecordStatus } from "models/appRecord";
import ImageUrl from "components/app/image-url/ImageUrl";
import { Snackbar } from "components";
import { ShimmerDepartmentRender, ShimmerStaffRender } from "components/app/shrimmer/Shrimmer";
import BtnGoToTop from "components/app/btn-go-to-top/BtnGoToTop";
import appStore from "store/appStore";
import DailogEditAndAddStaff from "./dialogStaff/DailogEditAndAddStaff";
// import StaffAction from "./StaffAction";
import UploadEmployeeImage from "components/app/upload-profile/UploadEmployeeImage";
import SkeletonMusicLibrariesTable from "pages/account-detail/music-libraries/skeleton/SkeletonMusicLibrariesTable";
import { useDispatch } from "react-redux";
import { setIndexs } from "store/header";
import { Popover, PopoverContent, PopoverTrigger } from "components/ui/popover";
import { noneProfile, iconRemove, logoutIcon } from "assets";
import DailogRoster from "./dialogStaff/DailogRoster";
import SearchBarStaff from "components/app/search-bar/SearchBarStaff";
import HoverCardDetail from "pages/hover-card-detail/HoverCardDetail";
import { faLock } from "@fortawesome/free-solid-svg-icons";
import printJS from "print-js";
import { Sheet, SheetContent, SheetDescription, SheetHeader, SheetTitle, SheetTrigger } from "components/ui/sheet";
import { ScrollArea, ScrollBar } from "components/ui/scroll-area";
import SettingShopDetail from "./setting-shop-detail/SettingShopDetail";
import PageEditAndAddStaff from "./dialogStaff/PageEditAndAddStaff";
import DialogUploadStaff from "./dialogStaff/DialogUploadStaff";
import DatePicker from "components/app/function/DatePicker";
import { Service } from "utils/services";
import StaffAction from "./StaffAction";
import useUrlString from "./useUrlString";

export default function Staff() {
  const dataStaff: any = StaffAction();
  const location = useLocation();
  const { handleClickUrl, hanleClickRemoveURl } = useUrlString();

  console.log(dataStaff?.userShopShiftGroup, "userShopShiftGroup");

  const [dobStaff, setDobStaff] = useState(new Date().toISOString().split("T")[0]); // "2025-05-05"

  const [isDialogOpenAddAndEditStaff, setisDialogOpenAddAndEditStaff] = useState<boolean>(false);
  //--------------------------staff----------------------

  const { showDialogConfirm } = appStore();
  useState<boolean>(false);
  const { token } = useAppSelector((state) => state.auth);
  const searchParams = new URLSearchParams(location.search);
  const shopId = searchParams.get("id");
  const [selectedProductGroupCode, setSelectedProductGroupCode] = useState<string>("");
  const selectedProductGroupCodeRef = useRef(selectedProductGroupCode);
  const [itemGroups, setItemGroups] = useState<any>();
  const [selectProducts, setSelectProducts] = useState<boolean>(false);

  const [editItemCategories, setEditItemCategories] = useState<any>(null);
  // const [checkBoxActive, setCheckBoxActive] = useState<any>();
  const [selectedProductIds, setSelectedProductIds] = useState<string[]>([]);

  const [hovered, setHovered] = useState(false);
  const handleClickCategory = ({ categoryName, groupId }: { categoryName: string; groupId: string }) => {
    if (selectedProductGroupCode === categoryName) return;
    setSelectedProductGroupCode(categoryName);
    selectedProductGroupCodeRef.current = categoryName;
  };
  const loadingProductState = {
    currentPage: 1,
    currentIndex: 0,
    nextPageUrl: "",
    totalRecord: 0,
    loadingStatus: AppRecordStatus.loading,
  };

  // -----------------------------shop Employee-------------------------------------
  const [shopEmployee, setShopEmployee] = useState<any>();
  const [shopEmployeeLoading, setShopEmployeeLoading] = useState<any>(null);
  const [shopEmployeeLoadingState, setShopEmployeeLoadingState] = useState<any>(null);
  const [view, setView] = useState("card");
  const listRef = useRef<any>(null);
  const { btnToggle, btnSearchStaff } = useAppSelector((state) => state.header);

  const getShopEmployeeSearch = async () => {
    setShopEmployeeLoadingState(true);
    try {
      const url = `${RouteApi.getShopEmployeeSearch}token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: dataStaff?.searchTextInput,
        department: selectedProductGroupCode,
        is_deleted: btnToggle ? 1 : 0,
        working_date: dobStaff,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setShopEmployeeLoadingState(false);

        const stateRecord: AppRecord = {
          currentPage: 1,
          currentIndex: 0,
          nextPageUrl: response["user_shop_employees"]["next_page_url"] ?? "",
          totalRecord: 0,
          loadingStatus: response["user_shop_employees"]["next_page_url"] != null ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        };
        setShopEmployee(response.user_shop_employees);

        setShopEmployeeLoading(stateRecord);
      } else {
        setShopEmployeeLoadingState(false);

        console.log(response, "error fetch shop employee ");
      }
    } catch (error: any) {
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[getShopEmployeeSearch]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  // fetchMoreShopEmployeeSearch
  const fetchMoreShopEmployeeSearch = async ({ next }: { next: string }) => {
    if (!next) return;

    setShopEmployeeLoading({
      ...loadingProductState,
      loadingStatus: AppRecordStatus.loadingMore,
    });

    try {
      const responses = await RequestApi(next);

      if (responses.status === "success") {
        const newEmployees = responses["user_shop_employees"]["data"];
        const nextPage = responses["user_shop_employees"]["next_page_url"];

        const updatedData = [...(shopEmployee?.data || []), ...newEmployees];

        setShopEmployee({
          ...responses["user_shop_employees"],
          data: updatedData,
        });

        setShopEmployeeLoading({
          ...loadingProductState,
          nextPageUrl: nextPage ?? "",
          loadingStatus: nextPage ? AppRecordStatus.loaded : AppRecordStatus.noLoadMore,
        });
      }
    } catch (error) {
      console.error("Failed to fetch more employees:", error);
    }
  };
  useEffect(() => {
    if (listRef.current && shopEmployeeLoading?.nextPageUrl && listRef.current.scrollHeight < window.innerHeight) {
      fetchMoreShopEmployeeSearch({
        next: shopEmployeeLoading?.nextPageUrl,
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [shopEmployee?.data]);

  useEffect(() => {
    getShopEmployeeSearch();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [dataStaff?.searchTextInput, selectedProductGroupCode, btnToggle, btnSearchStaff, dobStaff]);
  useEffect(() => {
    dataStaff?.fetchDepartment();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  const submitDeleteShopEmployee = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitDeleteShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_ids: selectedProductIds,
        shop_id: shopId,
        permanence_deleted: btnToggle ? 2 : 0,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            dataStaff?.setAllsetDepartment(responses.user_shop_departments);
            setShopEmployee((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => !selectedProductIds.includes(item.id)),
              };
            });
            setSelectProducts(false);
            setSelectedProductIds([]);
          } else {
          }
        })
        .catch((err) => {});
    } catch (error) {
      AppLog.show({
        message: `[submitDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const submitUndoDeleteShopEmployee = async () => {
    try {
      let url: string = "";
      url = RouteApi.submitUndoDeleteShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_ids: selectedProductIds,
        shop_id: shopId,
      };
      await RequestApi(url, { data })
        .then((responses) => {
          if (responses.status === "success") {
            dataStaff?.setAllsetDepartment(responses.user_shop_departments);
            setShopEmployee((prevItemGroups: any) => {
              return {
                ...prevItemGroups,
                data: (prevItemGroups.data || []).filter((item: any) => !selectedProductIds.includes(item.id)),
              };
            });
            setSelectProducts(false);
            setSelectedProductIds([]);
          } else {
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } catch (error) {
      AppLog.show({
        message: `[submitUndoDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  useEffect(() => {
    const savedView = localStorage.getItem("staff-display-layout");
    if (savedView) {
      setView(savedView);
    }
  }, [dataStaff?.searchTextInput, selectedProductGroupCode]);

  //---------------------submit Create and Update staffs--------------------
  const [editEmloyeeId, setEditEmloyeeId] = useState<any>(null);
  const [departmentName, setDepartmentName] = useState<any>();
  const [dob, setDob] = useState<any>();
  const [joinedDate, setJoinedDate] = useState<any>();
  const [probationDate, setProbationDate] = useState<any>();
  const [lastWorkingDate, setLastWorkingDate] = useState<any>();
  const [nationality, setNationality] = useState<any>();
  const [religion, setReligion] = useState<any>();
  const [bankAccount, setBankAccount] = useState<any>();
  const [paymenthod, setPaymethod] = useState<any>();
  const [permissions, setPermissions] = useState<any>();
  const [emergencyContact, setEmergencyContact] = useState({
    emergency_contact_name: "",
    emergency_contact_phone_no: "",
    emergency_contact_email: "",
    family_dependent: "",
  });
  // -------------personalInfo state------------
  const [personalInfo, setPersonalInfo] = useState<any>({
    local_name: "",
    english_name: "",
    gender: "male",
    marital_status: "single",
    id_card_no: "",
    passport_no: "",
    phone_no: "",
    phone_no_2: "",
    email: "",
    address: "",
    permanent_address: "",
  });
  // ----------------JobInfo state------------------
  const [jobInfo, setJobInfo] = useState({
    card_no: "",
    attendance_card_no: "",
    nssf_no: "",
    position: "",
    basic_salary: "",
    end_probation_remark: "",
    food_allownace: "",
    phone_allownace: "",
    housing_allownace: "",
    permission: "",
  });
  const [isCreateStaff, setIsCreateStaff] = useState<boolean>(false);

  const [loadingSubmitCreateUpdateStaff, setLoadingSubmitCreateUpdateStaff] = useState<boolean>(false);
  const clearData = () => {
    setEmergencyContact({
      emergency_contact_name: "",
      emergency_contact_phone_no: "",
      emergency_contact_email: "",
      family_dependent: "",
    });
    setJobInfo({
      card_no: "",
      attendance_card_no: "",
      nssf_no: "",
      position: "",
      basic_salary: "",
      end_probation_remark: "",
      food_allownace: "",
      phone_allownace: "",
      housing_allownace: "",
      permission: "",
    });
    setPersonalInfo({
      local_name: "",
      english_name: "",
      gender: "male",
      marital_status: "single",
      id_card_no: "",
      passport_no: "",
      phone_no: "",
      phone_no_2: "",
      email: "",
      address: "",
      permanent_address: "",
      bank_account_no: "",
    });

    setDob("");
    setNationality("");
    setPaymethod("");
    setProbationDate("");
    setJoinedDate("");
    setReligion("");
    setBankAccount("");
  };
  const [shiftGroupId, setShiftGroupId] = useState<any>();

  const onSubmitCreateAndUpdateStaff = async () => {
    if (!departmentName) return;
    setLoadingSubmitCreateUpdateStaff(true);
    const {
      local_name,
      english_name,
      gender,
      marital_status,
      id_card_no,
      passport_no,
      phone_no,
      phone_no_2,
      employee_account_id,
      employee_telegram_id,
      email,
      address,
      permanent_address,
      bank_account_no,
    } = personalInfo;
    const { emergency_contact_name, emergency_contact_phone_no, emergency_contact_email, family_dependent } = emergencyContact;
    const { card_no, attendance_card_no, nssf_no, position, basic_salary, end_probation_remark, food_allownace, phone_allownace, housing_allownace } = jobInfo;
    try {
      let url: string = "";
      url = isCreateStaff === true ? RouteApi.submitInsertShopEmployee : RouteApi.submitUpdateShopEmployee;
      url += `token=${token}`;
      const data = {
        employee_id: editEmloyeeId,
        shop_id: shopId,
        employee: {
          // ---personalInfo--
          local_name,
          english_name,
          gender,
          date_of_birth: dob,
          marital_status,
          nationality,
          pay_method: paymenthod,
          permissions: permissions,
          religion: religion,
          id_card_no,
          passport_no,
          bank_account_no,
          phone_no,
          phone_no_2,
          email,
          employee_account_id,
          employee_telegram_id,
          address,
          permanent_address,

          // -----mergency-------
          emergency_contact_name,
          emergency_contact_phone_no,
          emergency_contact_email,
          family_dependent,
          // -------job info --------
          // last_working_date,
          card_no,
          attendance_card_no,
          nssf_no,
          position,
          basic_salary,
          food_allownace,
          phone_allownace,
          housing_allownace,
          end_probation_remark,
          probation_date: probationDate,
          last_working_date: lastWorkingDate,
          joined_date: joinedDate,
          department: departmentName,
          shift_group_id: shiftGroupId,
          office_phone_no: "",
          // phone_no_2: "",
          extension_no: "",
        },
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        hanleClickRemoveURl("staff_id");
        setOpenPopoverIndex(null);
        setShopEmployeeDetail(null);
        setEditEmloyeeId(null);
        dataStaff?.setAllsetDepartment(response.user_shop_departments);
        setLoadingSubmitCreateUpdateStaff(false);
        setShopEmployee((prevItemGroups: any) => {
          const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === response.user_shop_employee.id ? { ...item, ...response.user_shop_employee } : item));
          const exists = updatedData.some((item: any) => item.id === response.user_shop_employee.id);
          if (!exists) {
            updatedData.push(response.user_shop_employee);
          }
          return {
            ...prevItemGroups,
            data: updatedData,
          };
        });
        clearData();
        setisDialogOpenAddAndEditStaff(false);
      } else {
        setLoadingSubmitCreateUpdateStaff(false);

        console.log("error onsubmit create and update");
      }
    } catch (error) {
      setLoadingSubmitCreateUpdateStaff(false);
    }
  };
  // ------------get shop staff detail---------
  const [loadingFetchDataShopEmployeeDetail, setLoadingFetchDataShopEmployeeDetail] = useState<boolean>(false);
  const [ShopEmployeeDetail, setShopEmployeeDetail] = useState<any>(null);
  const getShopEmployeeDetail = async (id: any) => {
    setLoadingFetchDataShopEmployeeDetail(true);
    try {
      const url = `${RouteApi.getShopEmployeeDetail}token=${token}`;
      const data = {
        shop_id: shopId,
        employee_id: id,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingFetchDataShopEmployeeDetail(false);
        setShopEmployeeDetail(response.user_shop_employee);
      } else {
      }
    } catch (error: any) {
      setLoadingFetchDataShopEmployeeDetail(false);

      AppLog.show({
        message: `[submitUndoDeleteShopEmployee]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  useEffect(() => {
    const url = new URLSearchParams(location.search);
    const requestId: any = url.get("staff_id");
    if (requestId) {
      (async () => {
        await getShopEmployeeDetail(requestId);
        setIsCreateStaff(false);
        setOpenPopoverIndex(1);
        setEditEmloyeeId(requestId);
      })();
    }
  }, []);
  const dispatch = useDispatch();
  const changeView = (selectedView: string) => {
    setView(selectedView);
    localStorage.setItem("staff-display-layout", selectedView);
  };
  const { indexs } = useAppSelector((state) => state.header);

  const allIds = Array.isArray(shopEmployee?.data) ? shopEmployee?.data?.map((item: any) => item.id) : [];
  const isAllSelected = allIds.length > 0 && allIds.every((id: any) => selectedProductIds.includes(id));

  const handleToggleSelectAll = () => {
    if (isAllSelected) {
      setSelectedProductIds([]);
    } else {
      setSelectedProductIds(allIds);
    }
  };

  const [isDailogRoster, setIsDailogIsRoster] = useState<boolean>(false);

  const [loading, setLoading] = useState(false);
  const [filteredData, setFilteredData] = useState<any[]>([]);

  const handleClick = (title: string) => {
    // setLoading(true);
    if (title === "Roster Setup") {
      setIsDailogIsRoster(true);
      const dataToFilter = Array.isArray(shopEmployee?.data) ? shopEmployee?.data : [];
      const result = dataToFilter.filter((item: any) => selectedProductIds.includes(item.id));
      setFilteredData(result);
      // setLoading(false);
    } else {
      Snackbar({
        message: "Coming soon",
        status: StatusMsg.warning,
      });
    }
  };
  const dataTimesheets = [
    {
      id: 1,
      title: "Roster Setup",
      label: "Scheduling Assigned per Operational",
      icon: (
        <div className="w-8 h-8 flex items-center justify-center bg-green-500 text-white p-2 rounded-full">
          <Calendar className="" />
        </div>
      ),
      description: [
        <>
          <p className="mb-2 font-medium text-sm dark:text-white">Configure employee work schedules, shifts, and availability across days or weeks.</p>
          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
            <li>Assign shifts to employees based on roles, departments, or availability.</li>
            <li>Customize working hours, break times, and rotation patterns.</li>
            <li>Ensure proper staffing coverage and reduce scheduling conflicts.</li>
            <li>Essential for accurate timesheets and payroll calculations.</li>
          </ul>
        </>,
      ],
    },
  ];

  const toggleItem = (item: any) => {
    setFilteredData((prev) => {
      const exists = prev.some((i) => i.id === item.id);
      return exists ? prev.filter((i) => i.id !== item.id) : [...prev, item];
    });
  };

  // ================print===============
  const [loadingPrint, setLoadingPrint] = useState<boolean>(false);

  const handlePrint = async () => {
    setLoadingPrint(true);
    try {
      const url = `${dataStaff?.storage_host_cluster_Id.host_name}/api-mobile-flipflop/v1/get-shop-employee-head-count-report?token=${token}`;
      const data = {
        shop_id: shopId,
        search_text: dataStaff?.searchTextInput,
        department: selectedProductGroupCode,
        storage_host_cluster_id: dataStaff?.storage_host_cluster_Id.id,
        working_date: dobStaff,
      };
      const response = await RequestApi(url, { data });
      if (response.status === "success") {
        setLoadingPrint(false);
        const pdfUrl = response?.pdf_url;
        const pdfResponse = await fetch(pdfUrl);
        const blob = await pdfResponse.blob();
        const blobUrl = URL.createObjectURL(blob);
        printJS({ printable: blobUrl, type: "pdf" });
      } else {
        setLoadingPrint(false);

        console.log(response, "error fetch shop employee");
      }
    } catch (error) {
      setLoadingPrint(false);
      setShopEmployeeLoadingState(false);

      AppLog.show({
        message: `[handlePrint]`,
        status: StatusMsg.error,
        error,
      });
    }
  };
  const [openPopoverIndex, setOpenPopoverIndex] = useState<number | null>(null);
  const [isDailogUploadStaff, setIsDailogUploadStaff] = useState(false);

  return (
    <BusinessSuiteContentLayout>
      {/* top bar */}
      <div className=" max-w-full z-50 w-auto bg-white  dark:bg-[#020817]">
        <div className="flex lg:flex-row md:flex-row flex-col justify-between left-0 items-center mb-3 w-full ">
          <div className="text-start lg:w-auto md:w-auto  w-full">
            <h1 className="font-semibold lg:text-lg md:text-md sm:text-sm">Staffs</h1>
            <p className=" whitespace-nowrap text-muted-foreground lg:text-md md:text-sm text-[13px]">Smart Scheduling, Attendance, and Performance Tracking</p>
          </div>
          {dataStaff?.warning ? (
            ""
          ) : (
            <nav className="border-gray-200 pt-5 flex items-center justify-between">
              <div className="flex items-center gap-3">
                {selectProducts && (
                  <div className="flex items-center justify-center px-5 py-2 bg-blue-500 rounded-full text-white">
                    Employee Selected {selectedProductIds.length} / {allIds.length}
                  </div>
                )}
                <>
                  {!selectProducts ? (
                    <>
                      <HoverCardDetail
                        title="Create New Staff "
                        description={
                          <>
                            <p className="mb-2 font-medium text-sm dark:text-white">Add new staff member to your team by entering their personal and job details.</p>
                            <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                              <li>Include contact information, role, and department.</li>
                              <li>Set permissions and access levels if applicable.</li>
                              <li>Ensures staff are properly tracked and managed in the system.</li>
                            </ul>
                          </>
                        }
                      >
                        <label
                          onClick={() => {
                            setIsCreateStaff(true);
                            // setisDialogOpenAddAndEditStaff(true);
                            setOpenPopoverIndex(1);
                            clearData();
                            setShopEmployeeDetail(null);
                            setLoadingFetchDataShopEmployeeDetail(false);
                          }}
                          htmlFor=""
                          className={`hover:border-3 transition-all duration-300 font-semibold rounded-full cursor-pointer lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300 
                        `}
                        >
                          <Plus className="font-semibold text-xl" />
                        </label>
                      </HoverCardDetail>
                    </>
                  ) : (
                    <>
                      {selectedProductIds.length > 0 && !btnToggle ? (
                        <>
                          {/* <HoverCardDetail
                          title="Save Staff "
                          description={
                            <>
                              <p className="mb-2 font-medium text-sm dark:text-white">Save all changes made to staff records. This updates the information in the system.</p>
                              <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                <li>Includes updates to roles, contact info, and permissions.</li>
                                <li>Changes take effect immediately upon saving.</li>
                                <li>Helps maintain accurate and current staff data.</li>
                              </ul>
                            </>
                          }
                        >
                          <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                            <Save />
                          </label>
                        </HoverCardDetail> */}
                          <Popover>
                            <PopoverTrigger asChild>
                              <label className=" font-semibold cursor-pointer rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300">
                                <AlignJustify />
                              </label>
                            </PopoverTrigger>
                            <PopoverContent className="w-80 relative">
                              {/* {loading && <div className="flex items-center absolute z-50 top-0 left-0 w-full h-full "></div>} */}
                              {dataTimesheets?.map((item: any, index: number) => {
                                return (
                                  <HoverCardDetail key={index} title={item.title} description={item.description}>
                                    <div
                                      key={index}
                                      className="gap-3 group  flex items-center px-3 py-2 rounded-md hover:bg-accent cursor-pointer"
                                      onClick={() => {
                                        handleClick(item.title);
                                      }}
                                    >
                                      <span className="group-hover:scale-110 transition-all duration-300">{item.icon}</span>

                                      <div className="flex flex-col ">
                                        <span className="font-medium leading-none lg:text-md md:text-sm text-[13px]">{item.title}</span>
                                        <span className="text-sm text-muted-foreground line-clamp-1">{item.label} </span>
                                      </div>
                                    </div>
                                  </HoverCardDetail>
                                );
                              })}
                            </PopoverContent>
                          </Popover>
                          <HoverCardDetail
                            title="Delete Staff "
                            description={
                              <>
                                <p className="mb-2 font-medium text-sm dark:text-white">
                                  Move the staff record to Trash. The employee will no longer appear in active lists but can be recovered.
                                </p>
                                <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                  <li>Soft delete allows for accidental removals to be undone.</li>
                                  <li>Trash keeps records safe until permanent deletion.</li>
                                  <li>Useful for managing staff turnover or temporary removals.</li>
                                </ul>
                              </>
                            }
                          >
                            <label
                              onClick={() =>
                                showDialogConfirm({
                                  titileButtonSubmit: "Yes, Delete",
                                  titileButtonCancel: "No, Cancel",
                                  title: "Delete",
                                  message: "Do you want to delete?",
                                  onSubmit() {
                                    submitDeleteShopEmployee();
                                  },
                                })
                              }
                              className="group transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                            >
                              <Trash2 className=" transition-colors duration-300" />
                            </label>
                          </HoverCardDetail>
                        </>
                      ) : (
                        btnToggle && (
                          <>
                            <HoverCardDetail
                              title="Restore Staff "
                              description={
                                <>
                                  <p className="mb-2 font-medium text-sm dark:text-white ">Restore an staff record from Trash back to the active staff list.</p>
                                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                    <li>Recovers all staff details and permissions.</li>
                                    <li>Useful if deletion was accidental or temporary.</li>
                                    <li>Immediately makes the staff visible in all relevant areas.</li>
                                  </ul>
                                </>
                              }
                            >
                              <label
                                onClick={() =>
                                  showDialogConfirm({
                                    titileButtonCancel: "No, Cancel",
                                    title: "Recover",
                                    message: "Do you want to recover?",
                                    onSubmit() {
                                      submitUndoDeleteShopEmployee();
                                    },
                                  })
                                }
                                className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                              >
                                <i className="fa-solid fa-trash-can-arrow-up text-xl   transition-colors duration-300"></i>
                              </label>
                            </HoverCardDetail>
                            <HoverCardDetail
                              title="Permanently Deleted"
                              description={
                                <>
                                  <p className="mb-2 font-medium text-sm dark:text-white ">Permanently delete the staff record from the system. This action cannot be undone.</p>
                                  <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                                    <li>Removes all data associated with the staff.</li>
                                    <li>The staff will no longer be available in any reports or listings.</li>
                                    <li>Make sure the staff is no longer required before deleting permanently.</li>
                                  </ul>
                                  {/* <p className="text-xs text-red-500 mt-1">⚠️ This is irreversible.</p> */}
                                </>
                              }
                            >
                              <label
                                onClick={() =>
                                  showDialogConfirm({
                                    titileButtonCancel: "No, Cancel",
                                    title: "Permanance Delete",
                                    message: "Do you want to permanance delete?",
                                    onSubmit() {
                                      submitDeleteShopEmployee();
                                    },
                                  })
                                }
                                className="group  hover:border-3  transition-all duration-300 font-semibold cursor-pointer rounded-full 
                                                             lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center text-md border border-gray-300"
                              >
                                <img
                                  src={iconRemove}
                                  className="w-7 h-7 transition duration-300 filter  group-hover:hue-rotate-[330deg] group-hover:saturate-[5] dark:invert"
                                  alt="icon"
                                />
                              </label>
                            </HoverCardDetail>
                          </>
                        )
                      )}
                    </>
                  )}
                </>
                {!selectProducts ? (
                  <HoverCardDetail
                    title="Select Staff"
                    description={
                      <>
                        <p className="mb-2 font-medium text-sm dark:text-white">Select multiple staff records in the current list for bulk actions.</p>
                        <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                          <li>Efficiently manage multiple records at once.</li>
                          <li>Ideal for bulk deletion, recovery, or updates.</li>
                          <li>Review your selection carefully before applying changes.</li>
                        </ul>
                      </>
                    }
                  >
                    <label
                      htmlFor=""
                      className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold  rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                    >
                      <CircleStop
                        onClick={() => {
                          setSelectProducts(true);
                          dispatch(setIndexs(""));
                        }}
                        className="text-sm"
                      />
                    </label>
                  </HoverCardDetail>
                ) : (
                  <>
                    <HoverCardDetail
                      title="Select All Staff "
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select all staff records in the current list for bulk actions.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Efficiently manage multiple records at once.</li>
                            <li>Ideal for bulk deletion, recovery, or updates.</li>
                            <li>Review your selection carefully before applying changes.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        className={`group hover:border-blue-500 hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 
                                                  flex items-center justify-center cursor-pointer border 
                                                  ${isAllSelected ? "border-blue-500 border-2" : "border-gray-300"} text-md`}
                      >
                        <CircleCheck
                          onClick={() => {
                            handleToggleSelectAll();
                          }}
                          className={` group-hover:text-white group-hover:bg-blue-500 ${
                            isAllSelected ? "bg-blue-500 text-white rounded-full" : " rounded-full"
                          } transition-colors duration-300`}
                        />
                      </label>
                    </HoverCardDetail>
                    <HoverCardDetail
                      title="Select Staff"
                      description={
                        <>
                          <p className="mb-2 font-medium text-sm dark:text-white">Select multiple staff records in the current list for bulk actions.</p>
                          <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                            <li>Efficiently manage multiple records at once.</li>
                            <li>Ideal for bulk deletion, recovery, or updates.</li>
                            <li>Review your selection carefully before applying changes.</li>
                          </ul>
                        </>
                      }
                    >
                      <label
                        htmlFor=""
                        className="hover:border-3 hover:scale-110 transition-all duration-300 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <CircleOff
                          onClick={() => {
                            setSelectedProductIds([]);
                            setSelectProducts(false);
                          }}
                          className="text-sm"
                        />
                      </label>
                    </HoverCardDetail>
                  </>
                )}
              </div>
              {loadingPrint ? (
                <label
                  onClick={() => {
                    handlePrint();
                  }}
                  htmlFor=""
                  className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                >
                  <Loader className="animate-spin" />
                </label>
              ) : (
                <HoverCardDetail
                  title="Daily Attendance Detail Report"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm text-gray-800">View and analyze detailed attendance records for each employee on a daily basis.</p>
                      <ul className="list-disc pl-5 text-sm text-gray-700 space-y-1">
                        <li>Monitor clock-in/out times, absences, and late entries.</li>
                        <li>Track working hours, overtime, and shift compliance.</li>
                        <li>Export reports for HR reviews or payroll processing.</li>
                        <li>Identify patterns for attendance-related issues.</li>
                      </ul>
                    </>
                  }
                >
                  <label
                    onClick={() => {
                      handlePrint();
                    }}
                    htmlFor=""
                    className="hover:border-3 hover:scale-110 transition-all  duration-300 ms-3 font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                  >
                    <PrinterCheck />
                  </label>
                </HoverCardDetail>
              )}
              <div className="flex items-center gap-2 ms-5 ">
                <DatePicker
                  className="py-4 h-[40px] w-[200px] border border-gray-300"
                  onChange={(value: any) => {
                    setDobStaff(value);
                  }}
                  value={dobStaff}
                />
              </div>
              {/* Search & View Switch */}
              <div className="flex items-center gap-2">
                <div className="flex-1 ms-4 me-2">
                  <div className="relative">
                    <SearchBarStaff
                      onValueChange={(value) => {
                        dataStaff?.setSearchTextInput(value);
                      }}
                    />
                  </div>
                </div>

                {/* View Toggle Button */}
                <HoverCardDetail
                  title="Reset"
                  description={
                    <>
                      <p className="mb-2 font-medium text-sm dark:text-white">Switch between different layouts to view staff records in the format you prefer.</p>
                      <ul className="list-disc pl-5 text-sm dark:text-gray-300 space-y-1">
                        <li>
                          <strong>Card View:</strong> Shows each staff as an individual card with profile info and actions.
                        </li>
                        <li>
                          <strong>Table View:</strong> Displays staff in a structured table for sorting, scanning, and bulk actions.
                        </li>
                        <li>Use the layout that best suits your workflow or screen size.</li>
                      </ul>
                    </>
                  }
                >
                  <div className="relative">
                    {view === "card" ? (
                      <button
                        onClick={() => changeView("table")}
                        className="font-semibold rounded-full lg:w-10 lg:h-10 md:w-10 md:h-10 w-8 h-8 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        <Grid2x2 className="font-semibold size-5" />
                      </button>
                    ) : (
                      <button
                        onClick={() => changeView("card")}
                        className="font-semibold rounded-full w-10 h-10 flex items-center justify-center cursor-pointer border border-gray-300 text-md"
                      >
                        {/* <WalletCards  /> */}
                        <CreditCard className="text-xl" />
                      </button>
                    )}
                  </div>
                </HoverCardDetail>
              </div>
            </nav>
          )}
        </div>
        {/* scrollCategories */}
        {dataStaff?.warning ? (
          ""
        ) : (
          <div
            onMouseEnter={() => setHovered(true)}
            onMouseLeave={() => setHovered(false)}
            className={`w-full grid grid-cols-1  pt-2 mb-2 pe-2 overflow-x-auto space-x-2 no-scrollbar ${hovered ? "scrollbar-visible" : "scrollbar-custom"}`}
          >
            {/* Hover Overflow Scroll Container */}
            <div className="relative w-full ">
              <div className="flex space-x-2 w-full">
                {/* Add Category */}

                {/* "All" Category */}
                <div
                  onClick={() => {
                    setEditItemCategories("");

                    if (selectedProductGroupCode === "All") {
                      setEditItemCategories("");
                      if (itemGroups?.data?.length) {
                      }
                    }
                    handleClickCategory({
                      categoryName: "",
                      groupId: "",
                    });
                  }}
                  className={`lg:w-14 lg:h-14 md:w-12 md:h-12 w-10 h-10 px-4 flex items-center justify-center border rounded-md mr-1 cursor-pointer font-semibold ${
                    selectedProductGroupCode === "" ? "bg-gray-200 dark:bg-accent dark:hover:bg-slate-900" : "dark:hover:bg-slate-900"
                  }`}
                >
                  <span className="lg:text-sm md:text-sm text-[12px]">All</span>
                </div>
                {/* Product Categories */}
                <div className="space-x-2 flex ">
                  {dataStaff?.loadingFetchDataDepartment ? (
                    <>
                      <ShimmerDepartmentRender />
                    </>
                  ) : (
                    <>
                      {dataStaff?.alldepartment?.map((group: any) => (
                        <div key={group.id} className="flex items-center">
                          {group.department && (
                            <div
                              className={`flex items-center  w-auto whitespace-nowrap lg:h-14 md:h-12 h-10  border rounded-md cursor-pointer font-semibold 
                                ${
                                  selectedProductGroupCode === (group?.department ? group.department.toString() : "")
                                    ? "dark:bg-accent dark:hover:bg-slate-900 bg-gray-200"
                                    : "dark:hover:bg-slate-900"
                                }`}
                              onClick={() => {
                                setEditItemCategories(group.department);
                                handleClickCategory({
                                  categoryName: group?.department ?? "", // Ensure it's a string or fallback to ""
                                  groupId: group?.product_group_id,
                                });
                              }}
                            >
                              <div className="flex group ">
                                <p className="xl:text-md text-sm font-semibold line-clamp-2 px-2 overflow-hidden flex items-center justify-center">
                                  {group?.department ?? "No department"}
                                </p>
                              </div>
                            </div>
                          )}
                        </div>
                      ))}
                    </>
                  )}
                </div>
              </div>
            </div>
          </div>
        )}
      </div>
      {/* {view === "card" ? <></> : <>{shopEmployeeLoadingState && <SkeletonMusicLibrariesTable />}</>} */}
      {dataStaff?.warning ? (
        <div className="flex flex-col gap-2 items-center justify-center h-[70vh] w-full  ">
          <CircleAlert className="text-yellow-500 mx-auto w-[200px] h-[200px]" />
          <h1
            className={`text-[30px] font-semibold   ${
              dataStaff?.errorStatus?.title === "success" || dataStaff?.errorStatus?.title === "info"
                ? "text-green-500"
                : dataStaff?.errorStatus?.title === "warning"
                ? "text-yellow-500"
                : "text-red-500"
            }`}
          >
            {dataStaff?.errorStatus?.title === "success"
              ? "success"
              : dataStaff?.errorStatus?.title === "info"
              ? "Infomation"
              : dataStaff?.errorStatus?.title === "warning"
              ? "warning"
              : "error"}
          </h1>
          <span className=" text-muted-foreground text-md pt-3 ">{dataStaff?.errorStatus?.message}</span>
        </div>
      ) : (
        <div className="pb-3 h-full mt-5 ">
          {view === "card" ? (
            <>
              {shopEmployeeLoadingState ? (
                <>
                  <ShimmerStaffRender />
                </>
              ) : (
                <InfiniteScroll
                  dataLength={shopEmployee?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeeSearch({
                      next: shopEmployeeLoading.nextPageUrl,
                    })
                  }
                  hasMore={!!shopEmployeeLoading?.nextPageUrl}
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    <div ref={listRef} className={`grid grid-cols-2 md:grid-cols-5 ${window.innerWidth <= 1500 ? "lg:grid-cols-6" : "lg:grid-cols-8"} gap-y-3 gap-x-2 mb-10 `}>
                      {shopEmployee?.data?.map((item: any, index: number) => {
                        return (
                          <div
                            onClick={() => {
                              // if (item.is_deleted === 0) {
                              if (selectProducts) {
                                setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                toggleItem(item);
                                return;
                              } else {
                                if (item.is_deleted === 0) {
                                  dispatch(setIndexs(item.id));

                                  setIsCreateStaff(false);
                                  setOpenPopoverIndex(1);
                                  setEditEmloyeeId(item.employee_id);
                                  getShopEmployeeDetail(item.employee_id);
                                  handleClickUrl(item?.id, "staff_id");
                                }
                              }
                            }}
                            key={index}
                            className={`group relative z-1 w-full max-w-sm border rounded-lg cursor-pointer ${selectedProductIds.includes(item.id) ? "" : ""}`}
                          >
                            <div className=" w-full relative overflow-hidden  aspect-square ">
                              {/* <ImageUrl className="rounded-t-md cursor-pointer w-full h-full object-cover" src={!item.picture ? noneProfile : item.picture} alt="" /> */}
                              <img
                                className={`rounded-t-md cursor-pointer w-full h-full object-cover ${item.is_deleted === 1 && "opacity-50"} `}
                                src={!item.picture ? noneProfile : item.picture}
                                alt=""
                              />
                              <div
                                className={` ${
                                  selectedProductIds.includes(item.id) ? "bg-white" : ""
                                } w-4 h-4 rounded-full flex items-center justify-center absolute left-2 top-2 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                              >
                                {selectedProductIds.includes(item.id) ? (
                                  <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                ) : (
                                  <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full "></i>
                                )}
                              </div>
                              {selectProducts === true && <div className="absolute inset-0 mx-auto top-[50%] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}

                              {item.is_deleted === 0 ? (
                                <button
                                  onClick={(event) => {
                                    event.stopPropagation();
                                  }}
                                  className="absolute opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 inset-0 mx-auto top-[50%] cursor-pointer  w-8 h-8 text-white bg-black/50 rounded-full p-1"
                                >
                                  {/* <UploadEmprofile /> */}
                                  <UploadEmployeeImage
                                    editItemEmployee={item}
                                    onUploadSuccess={({ res, name }) => {
                                      setShopEmployee((prevItemGroups: any) => {
                                        const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                                        const exists = updatedData.some((item: any) => item.id === res.id);
                                        if (!exists) {
                                          updatedData.push(res);
                                        }
                                        return {
                                          ...prevItemGroups,
                                          data: updatedData,
                                        };
                                      });
                                    }}
                                  />
                                </button>
                              ) : (
                                <button
                                  onClick={(event) => {
                                    event.stopPropagation();
                                  }}
                                  className="font-semibold  absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[50%] cursor-pointer w-[80px] h-8 bg-black/50 rounded-full p-1"
                                >
                                  Deleted
                                </button>
                              )}
                            </div>
                            <div className={`p-4 ${indexs === item.id ? "bg-gray-200 dark:bg-[#0e172c] rounded-b-md " : ""} `}>
                              <h4 className="text-md font-semibold line-clamp-2 overflow-hidden h-[25px] text-[15px] ">{item?.local_name}</h4>
                              <span className="text-sm line-clamp-1 overflow-hidden h-[20px]  ">{item?.department}</span>

                              <p className=" font-semibold line-clamp-2 text-sm text-muted-foreground h-[20px]"> {item.position}</p>

                              <p className="font-semibold line-clamp-2 text-sm  text-muted-foreground h-[20px]">
                                {/* {item.joined_date} */}
                                {(() => {
                                  const date = new Date(item.joined_date);
                                  const day = date.getDate();
                                  const weekday = date.toLocaleDateString("en-GB", {
                                    weekday: "short",
                                  });
                                  const month = date.toLocaleDateString("en-GB", {
                                    month: "short",
                                  });

                                  const year = date.getFullYear();
                                  return `${weekday}, ${day}-${month}-${year}`;
                                })()}
                              </p>
                            </div>
                          </div>
                        );
                      })}
                      {!shopEmployee?.next_page_url ? (
                        <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                          <b>Nothing more to load!</b>
                        </p>
                      ) : (
                        ""
                      )}
                    </div>
                  </>
                </InfiniteScroll>
              )}
            </>
          ) : (
            <>
              {shopEmployee ? (
                <InfiniteScroll
                  dataLength={shopEmployee?.data?.length || 0}
                  next={() =>
                    fetchMoreShopEmployeeSearch({
                      next: shopEmployeeLoading.nextPageUrl,
                    })
                  }
                  scrollThreshold="90%"
                  hasMore={!!shopEmployeeLoading.nextPageUrl}
                  scrollableTarget="scrollableDiv"
                  loader={
                    <div className="absolute bottom-2 left-0 w-full flex justify-center mt-5">
                      <LoaderCircle size={30} className="animate-spin text-yellow-400" />
                    </div>
                  }
                >
                  <>
                    {shopEmployeeLoadingState ? (
                      <SkeletonMusicLibrariesTable />
                    ) : (
                      <table className="min-w-full border-collapse mb-20 rounded-md overflow-hidden">
                        <thead className="sticky top-0 left-0 text-xs text-gray-700  bg-gray-300 dark:bg-[#2c3a52] dark:text-gray-400">
                          <tr className="border-none  text-[15px]">
                            <th className="py-5 text-start  px-4 first:rounded-tl-md last:rounded-tr-md ">Image</th>
                            <th className=" px-4 text-start ">Staff Info. </th>
                            <th className="text-start  pe-[70px] ps-4">Status</th>
                            <th className="text-start px-4">Contact</th>
                            <th className="text-start  px-4">Emergency Contact </th>
                            <th className="text-start  px-4">Department</th>
                            <th className="text-start  px-4">ID </th>
                            <th className="text-start  pe-[70px] "> Joined Date</th>
                            <th className="text-start  px-4"> Manager</th>
                            <th className="text-start  px-4"> Benefit</th>
                          </tr>
                        </thead>
                        <tbody ref={listRef}>
                          {shopEmployee?.data?.map((item: any, index: number) => {
                            return (
                              <tr
                                onClick={() => {
                                  // if (item.is_deleted === 0) {
                                  if (selectProducts) {
                                    setSelectedProductIds((prev) => (prev.includes(item.id) ? prev.filter((id) => id !== item.id) : [...prev, item.id]));
                                    return;
                                  } else {
                                    if (item.is_deleted === 0) {
                                      dispatch(setIndexs(item.id));
                                      setOpenPopoverIndex(1);
                                      setIsCreateStaff(false);
                                      setEditEmloyeeId(item.employee_id);
                                      getShopEmployeeDetail(item.employee_id);
                                      handleClickUrl(item?.id, "staff_id");
                                    }
                                  }
                                }}
                                key={index}
                                className={`group text-center cursor-pointer ${
                                  index % 2 === 0 ? "bg-gray-100 dark:bg-[#1e293b] " : "bg-gray-200 dark:bg-[#2c3a52] "
                                } hover:bg-gray-300`}
                              >
                                <td className="relative w-[100px] h-[100px]  ">
                                  <div
                                    className={` ${
                                      selectedProductIds.includes(item.id) ? "bg-white" : ""
                                    } w-4 h-4 rounded-full flex items-center justify-center absolute left-[6px] top-[6px] z-50 text-xl  ${!selectProducts ? " hidden" : " block"}`}
                                  >
                                    {selectedProductIds.includes(item.id) ? (
                                      <i className=" fa-solid  fa-circle-check text-blue-500 border-2 rounded-full border-white  "></i>
                                    ) : (
                                      <i className=" fa-regular fa-circle text-blue-500 border-2 border-transparent rounded-full "></i>
                                    )}
                                  </div>
                                  {selectProducts === true && <div className="absolute inset-0 mx-auto top-[32px] z-50  w-8 h-8  text-white  rounded-full p-1"></div>}
                                  {item.is_deleted === 0 ? (
                                    <button
                                      onClick={(event) => {
                                        event.stopPropagation(); // Prevents opening the edit dialog
                                      }}
                                      className="absolute opacity-0 group-hover:opacity-100 group-hover:scale-110 transition-all duration-300 inset-0 z-10  mx-auto mt-[35px] w-8 h-8 text-white bg-black/50 rounded-full p-1"
                                    >
                                      <UploadEmployeeImage
                                        editItemEmployee={item}
                                        onUploadSuccess={({ res, name }) => {
                                          setShopEmployee((prevItemGroups: any) => {
                                            const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                                            const exists = updatedData.some((item: any) => item.id === res.id);
                                            if (!exists) {
                                              updatedData.push(res);
                                            }
                                            return {
                                              ...prevItemGroups,
                                              data: updatedData,
                                            };
                                          });
                                        }}
                                      />
                                    </button>
                                  ) : (
                                    <button
                                      onClick={(event) => {
                                        event.stopPropagation();
                                      }}
                                      className="font-semibold text-sm z-50 absolute flex items-center justify-center text-white shadow-md shadow-red-500 inset-0 mx-auto top-[40%] cursor-pointer w-[70px] h-8 bg-black/50 rounded-full p-1"
                                    >
                                      Deleted
                                    </button>
                                  )}

                                  <img
                                    className={`w-full h-[100px] z-1 mx-auto relative  ${item.is_deleted === 1 && "opacity-50"} `}
                                    src={!item.picture ? noneProfile : item.picture}
                                    alt=""
                                  />
                                </td>
                                <td className="py-2 px-4 text-md  text-left align-top">
                                  <p className="text-[15px] font-bold "> {item.local_name}</p>
                                  <p className="text-md text-muted-foreground "> {item.english_name}</p>
                                  <p className="text-md text-muted-foreground ">{item?.nationality}</p>
                                </td>
                                <td className="py-2 px-4  text-md  text-left align-top text-nowrap">
                                  <p className="text-md "> {item?.gender}</p>
                                  <p className="text-md text-muted-foreground"> {item?.marital_status}</p>
                                  <p className="text-md flex items-center  gap-2  text-muted-foreground text-nowrap">
                                    {(() => {
                                      const date = new Date(item.date_of_birth);
                                      const day = date.getDate();
                                      const weekday = date.toLocaleDateString("en-GB", {
                                        weekday: "short",
                                      });
                                      const month = date.toLocaleDateString("en-GB", {
                                        month: "short",
                                      });

                                      const year = date.getFullYear();
                                      return `${weekday}, ${day}-${month}-${year}`;
                                    })()}
                                  </p>
                                </td>
                                <td className="py-2 px-4 text-md  text-left align-top">
                                  <p className="text-md "> {item?.phone_no}</p>
                                  <p className="text-md line-clamp-1 text-muted-foreground"> {item?.email}</p>
                                  <p className="text-md text-muted-foreground">{item?.address}</p>
                                </td>
                                <td className="py-2 px-4 text-md  text-left align-top">
                                  <p className="text-md "> {item?.emergency_contact_name}</p>
                                  <p className="text-md text-muted-foreground"> {item?.emergency_contact_phone_no}</p>
                                  <p className="text-md text-muted-foreground line-clamp-1">{item?.emergency_contact_email}</p>
                                </td>
                                <td className="py-2 px-4 text-md  text-left align-top">
                                  <p className="text-md line-clamp-1 "> {item?.department}</p>
                                  <p className="text-md text-muted-foreground "> {item?.position}</p>
                                  <div className="flex items-center gap-1 text-muted-foreground">
                                    <p className="text-md text-nowrap"> {Service.formatTime(item?.timesheet?.starting_time)}</p>
                                    {item?.timesheet?.starting_time && item?.timesheet?.ending_time && "-"}
                                    <p className="text-md text-nowrap "> {Service.formatTime(item?.timesheet?.ending_time)}</p>
                                  </div>
                                </td>
                                <td className="py-2 px-4  text-left align-top">
                                  {/* <p className="text-[15px] font-bold ">{item?.card_no}</p> */}
                                  <p className="text-[15px]  font-bold "> {item?.card_no}</p>

                                  <p className="text-md text-muted-foreground"> {item?.id_card_no}</p>
                                  <p className="text-md text-muted-foreground"> {item?.passport_no}</p>
                                </td>
                                <td className="py-2 text-md  text-left align-top text-nowrap">
                                  <p className="text-md flex gap-2 items-center text-nowrap  ">
                                    {item.joined_date &&
                                      (() => {
                                        const date = new Date(item.joined_date);
                                        const day = date.getDate();
                                        const weekday = date.toLocaleDateString("en-GB", {
                                          weekday: "short",
                                        });
                                        const month = date.toLocaleDateString("en-GB", {
                                          month: "short",
                                        });

                                        const year = date.getFullYear();
                                        return `${weekday}, ${day}-${month}-${year}`;
                                      })()}
                                  </p>

                                  <p className="text-md flex gap-2 text-muted-foreground text-nowrap">
                                    {!item.last_working_date
                                      ? ""
                                      : (() => {
                                          const date = new Date(item.last_working_date);
                                          const day = date.getDate();
                                          const weekday = date.toLocaleDateString("en-GB", {
                                            weekday: "short",
                                          });
                                          const month = date.toLocaleDateString("en-GB", {
                                            month: "short",
                                          });
                                          const year = date.getFullYear();
                                          return `${weekday}, ${day}-${month}-${year}`;
                                        })()}
                                  </p>
                                </td>
                                <td className=" text-left align-top ">
                                  {item?.managers?.map((managers: any, index: number) => {
                                    return (
                                      <div key={index} className="gap-3 flex items-center  rounded-md p-1  w-[180px] ">
                                        <ImageUrl src={!managers?.picture ? noneProfile : managers?.picture} className=" h-[45px] w-[45px] rounded-full" alt={managers?.picture} />
                                        <div className="flex flex-col text-start ">
                                          <span className="w-full font-medium line-clamp-1 leading-none lg:text-md md:text-sm text-[15px]">
                                            {managers?.local_name?.length > 12 ? `${managers?.local_name.slice(0, 12)}...` : managers?.local_name}
                                            {/* {item.mana} */}
                                          </span>
                                          <span className="text-sm text-muted-foreground line-clamp-1">
                                            {managers?.position?.length > 12 ? `${managers?.position.slice(0, 12)}...` : managers?.position}
                                          </span>
                                        </div>
                                      </div>
                                    );
                                  })}
                                </td>
                                <td className="py-2 px-4 text-md  text-left align-top">
                                  <p className="text-[15px]  font-bold "> {item?.basic_salary}</p>
                                  <p className="text-md text-muted-foreground"> {item?.pay_method}</p>
                                  <p className="text-md  text-muted-foreground">{item?.bank_account_no}</p>
                                </td>
                              </tr>
                            );
                          })}
                          {!shopEmployee?.next_page_url ? (
                            <p className="absolute bottom-0 left-0 w-full text-center mb-5 flex items-center justify-center">
                              <b>Nothing more to load!</b>
                            </p>
                          ) : (
                            ""
                          )}
                        </tbody>
                      </table>
                    )}
                  </>
                </InfiniteScroll>
              ) : (
                <></>
              )}
            </>
          )}
        </div>
      )}

      <DailogRoster
        onUploadSuccessRoster={({ status }) => {
          if (status === "success") {
            setSelectedProductIds([]);
            setSelectProducts(false);
          } else {
          }
        }}
        resetStatus={({ status }) => {
          // if (status === "yes") {
          //   const dataToFilter = Array.isArray(shopEmployee?.data) ? shopEmployee?.data : [];
          //   const result = dataToFilter.filter((item: any) => selectedProductIds.includes(item.id));
          //   setFilteredData(result);
          // } else {
          // }
        }}
        setLoading={setLoading}
        searchTextInput={dataStaff?.searchTextInput}
        setFilteredData={setFilteredData}
        editItemCategories={editItemCategories}
        filteredData={filteredData}
        isDailogRoster={isDailogRoster}
        setIsDailogIsRoster={setIsDailogIsRoster}
        userShopShiftGroup={dataStaff?.userShopShiftGroup}
      />
      <BtnGoToTop />
      <Sheet
        open={openPopoverIndex === 1}
        onOpenChange={(isOpen) => {
          setOpenPopoverIndex(isOpen ? 1 : null);
          setEditEmloyeeId(null);
          if (!isOpen) {
            hanleClickRemoveURl("staff_id");
          }
        }}
      >
        <SheetContent className="flex flex-col h-full sm:max-w-[1000px] justify-between p-3 pt-[50px]">
          <PageEditAndAddStaff
            onUploadSuccess={({ res, name }) => {
              if (name === "delete") {
                setShopEmployee((prevItemGroups: any) => {
                  return {
                    ...prevItemGroups,
                    data: (prevItemGroups.data || []).filter((item: any) => item.id !== res.id),
                  };
                });
              } else {
                setShopEmployee((prevItemGroups: any) => {
                  const updatedData = (prevItemGroups.data || []).map((item: any) => (item.id === res.id ? { ...item, ...res } : item));
                  const exists = updatedData.some((item: any) => item.id === res.id);
                  if (!exists) {
                    updatedData.push(res);
                  }
                  return {
                    ...prevItemGroups,
                    data: updatedData,
                  };
                });
              }
            }}
            // setEditItemCategories={setEditItemCategories}
            setIsDailogUploadStaff={setIsDailogUploadStaff}
            setOpenPopoverIndex={setOpenPopoverIndex}
            setPaymethod={setPaymethod}
            paymenthod={paymenthod}
            editItemCategories={editItemCategories}
            religion={religion}
            nationality={nationality}
            editEmloyeeId={editEmloyeeId}
            setEditEmloyeeId={setEditEmloyeeId}
            setDepartmentName={setDepartmentName}
            setShiftGroupId={setShiftGroupId}
            shiftGroupId={shiftGroupId}
            setReligion={setReligion}
            setBankAccount={setBankAccount}
            setNationality={setNationality}
            setProbationDate={setProbationDate}
            setLastWorkingDate={setLastWorkingDate}
            lastWorkingDate={lastWorkingDate}
            probationDate={probationDate}
            setJoinedDate={setJoinedDate}
            setDob={setDob}
            dob={dob}
            setEmergencyContact={setEmergencyContact}
            setJobInfo={setJobInfo}
            setPersonalInfo={setPersonalInfo}
            emergencyContact={emergencyContact}
            jobInfo={jobInfo}
            joinedDate={joinedDate}
            personalInfo={personalInfo}
            onSubmitCreateAndUpdateStaff={onSubmitCreateAndUpdateStaff}
            setUserShopShiftGroup={dataStaff?.setUserShopShiftGroup}
            userShopShiftGroup={dataStaff?.userShopShiftGroup}
            isCreateStaff={isCreateStaff}
            setIsCreateStaff={setIsCreateStaff}
            department={dataStaff?.department}
            isDialogOpenAddAndEditStaff={isDialogOpenAddAndEditStaff}
            setisDialogOpenAddAndEditStaff={setisDialogOpenAddAndEditStaff}
            loadingSubmitCreateUpdateStaff={loadingSubmitCreateUpdateStaff}
            loadingFetchDataShopEmployeeDetail={loadingFetchDataShopEmployeeDetail}
            ShopEmployeeDetail={ShopEmployeeDetail}
            setShopEmployeeDetail={setShopEmployeeDetail}
            clearData={clearData}
            selectedProductIds={selectedProductIds}
            departmentName={departmentName}
            setAllsetDepartment={dataStaff?.setAllsetDepartment}
            setShopEmployee={setShopEmployee}
            permissions={permissions}
            setPermissions={setPermissions}
          />
        </SheetContent>
      </Sheet>
      <DialogUploadStaff
        editItemCategories={editItemCategories}
        userShopShiftGroup={dataStaff?.userShopShiftGroup}
        setShopEmployee={setShopEmployee}
        setAllsetDepartment={dataStaff?.setAllsetDepartment}
        isDailogUploadStaff={isDailogUploadStaff}
        setIsDailogUploadStaff={setIsDailogUploadStaff}
        editEmloyeeId={editEmloyeeId}
        department={dataStaff?.department}
      />
    </BusinessSuiteContentLayout>
  );
}
